module.exports = __webpack_public_path__ + "img/logo.3c1ed50.png";